/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserNotificationPreferences } from './userNotificationPreferences';

export type UserUpdateNotificationPrefs = UserNotificationPreferences | null;
